module.exports = __webpack_public_path__ + "static/media/rent-kin.9997f26c.jpg";